module.exports = {"410502001":"东大街街道","410502002":"头二三街道","410502003":"甜水井街道","410502004":"东关街道","410502005":"南关街道","410502006":"西大街街道","410502008":"北大街街道","410502011":"西关街道","410502012":"紫薇大道街道","410502013":"光华路街道","410502014":"永明路街道","410502015":"中华路街道","410502101":"宝莲寺镇","410502102":"高庄镇","410502561":"步行街综合治理办公室","410502562":"北大街综合治理办公室"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410502.json
// module id = 1436
// module chunks = 0